
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="5504"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="产品分类">
							<c-select name="category_id" async @search="searchCategory" @change="categoryChange"></c-select>
						</m-search-item>
						<m-search-item label="品牌型号">
							<c-select name="brand_id" async @search="searchBrand"></c-select>
						</m-search-item>
						<m-search-item label="等级">
							<c-select name="level_type" :options="levelTypeOptions"></c-select>
						</m-search-item>
						<m-search-item label="背贴码">
							<c-input name="produce_unique_code"></c-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<c-input name="produce_imei"></c-input>
						</m-search-item>
						<m-search-item label="渠道类型">
						<c-select name="sale_channel_type" :options="saleChannelTypeDic"></c-select>
					</m-search-item>
						<m-search-item label="操作时间" colspan="2">
							<c-datetime range name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #product_info="{data}">
					<div class="m-product-info">
						<p class="m-product-info-name">
							<span v-if="data.level_name" class="m-tag" :class="levelClass(data.level_name)">{{data.level_name}}</span>
							<span>{{data.product_info || getProductText(data)}}</span>
						</p>
						<p class="m-product-info-code">背贴码：{{data.produce_unique_code}}</p>
						<p class="m-product-info-code">IMEI：{{data.produce_imei}}</p>
					</div>
				</template>

				<template #condition_info="{data}">
					<div class="m-condition">
						<p v-for="(item, i) in getConditionList(data)" :key="i">{{item}}</p>
					</div>
				</template>

				<template #overall_state="{data}">
					<c-state tag dict="saleOverallStateDic" :value="data.overall_state"></c-state>
				</template>

				<template #sale_price="{data}">
					<span class="m-price-info">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #b_report_state="{data}">
					<i v-if="data.b_report_state" class="tf-check tf" :class="qualityReportClass(data.b_report_state)"></i>
				</template>

				<template #c_report_state="{data}">
					<i v-if="data.c_report_state" class="tf-check tf" :class="qualityReportClass(data.c_report_state)"></i>
				</template>

				<template #sale_channel_type="{data}">
					<c-state tag dict="saleChannelTypeDic" :value="data.sale_channel_type"></c-state>
				</template>

				<template #is_dismantle="{data}">
					<span v-if="data.is_dismantle==1" class="m-dismantle-tag" title="已拆机">拆</span>
					<span v-else>-</span>
				</template>

<!--				<c-table-column-->
<!--					type="button"-->
<!--					label="操作"-->
<!--					width="160"-->
<!--					button-limit="6"-->
<!--				>-->
<!--					<template #default="{data}">-->
<!--					</template>-->
<!--				</c-table-column>-->
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		computed: {
		...mapState(['saleOverallStateDic', 'saleChannelTypeDic'])
	},

		data() {
			return {
				levelTypeOptions: [],
				qualityCheckOptions: [{
					name: '是',
					value: 1
				}, {
					name: '否',
					value: 2
				}],
				priceRatio: null
			}
		},

		mounted() {
			this.loadLevelOptions();
		},

		methods: {
			/*********加载等级选项**********/
			loadLevelOptions() {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LEVEL_TYPE'
					},
					success: data => {
						this.levelTypeOptions = data;
					}
				});
			},

			/*********搜索产品分类**********/
			searchCategory(keyword, resolve) {
				this.request({
					url: '/spu/category/options',
					data: {keyword},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********搜索品牌**********/
			searchBrand(keyword, resolve) {
				var search = this.$refs.search.get();
				this.request({
					url: '/spu/brand/options',
					data: {
						category_id: search.category_id,
						keyword
					},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********分类变更后清空品牌**********/
			categoryChange() {
				this.$refs.search.set({
					brand_id: ''
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********获取成色列表（成色按参考渠道展示）**********/
			getConditionList(data) {
				var list = [];
				if (data.condition_list && data.condition_list.length) {
					data.condition_list.forEach(item => {
						if (item.channel_name && item.condition_info) {
							list.push(item.channel_name + '：' + item.condition_info);
						}
					});
				}
				return list.length ? list : ['-'];
			},

			/*********质检报告状态样式（0不展示，1待发布橙色，2已发布绿色，3已下架红色）**********/
			qualityReportClass(val) {
				return {1: 'm-quality-pending', 2: 'm-quality-published', 3: 'm-quality-offshelf'}[val] || '';
			},

			/*********等级tag样式映射**********/
			levelClass(level) {
				if (!level) return '';
				if (level.indexOf('充新') >= 0 || level.indexOf('靓机') >= 0) return 'm-tag-good';
				if (level.indexOf('小花') >= 0) return 'm-tag-fair';
				if (level.indexOf('大花') >= 0 || level.indexOf('外爆') >= 0) return 'm-tag-bad';
				return '';
			},

			/*********上架（工具栏：需选中一条记录）**********/
			shelfProduct() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (selected.length != 1) {
					this.$message({message: '上架操作仅支持单个商品，请勾选一条记录', type: 'warn'});
					return;
				}
				if (![1, 3].includes(selected[0].overall_state)) {
					this.$message({message: '当前状态不支持上架', type: 'warn'});
					return;
				}
				this.openShelfChannel(selected[0]);
			},

			/*********打开上架渠道弹框**********/
			openShelfChannel(data) {
				this.globalDialog('saleShelfChannel', {
					data: data
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********下架（行内/批量）**********/
			batchOffShelf() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				var validList = selected.filter(item => item.overall_state == 2);
				if (!validList.length) {
					this.$message({message: '请勾选【已上架】状态的商品', type: 'warn'});
					return;
				}
				this.offShelf(validList);
			},

			offShelf(list) {
				if (!list.length) return;
				this.$confirm({
					message: '确认下架所选的' + list.length + '个渠道商品吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/product/offShelf',
							data: {
								channel_product_ids: list.map(item => item.channel_product_id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********批量返库**********/
			batchReturnToStock() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				var validList = selected.filter(item => [1, 2, 3].includes(item.overall_state));
				if (!validList.length) {
					this.$message({message: '请勾选【待上架/已上架/已下架】状态的商品', type: 'warn'});
					return;
				}
				this.$confirm({
					message: '确认将所选的' + validList.length + '个商品返库吗？返库后所有渠道将下架',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/product/batchReturnStock',
							data: {
								product_ids: validList.map(item => item.id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********改价**********/
			editPrice() {
				this.globalDialog('salePriceEdit', {
					data: {
						view_id: this.$refs.view.getViewId()
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********改价记录**********/
			viewPriceLog(data) {
				this.globalDialog('salePriceLog', {data});
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.m-ratio-tip {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		margin-left: 8px;
		font-size: 13px;
		color: #666;

		i {
			cursor: pointer;
			color: #2b7be4;
		}
	}

	.m-product-info {
		line-height: 20px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}

	.m-tag {
		display: inline-block;
		padding: 0 6px;
		height: 18px;
		line-height: 18px;
		font-size: 12px;
		border-radius: 2px;
		color: #fff;
		background: #2b7be4;

		&.m-tag-good {
			background: #19be6b;
		}
		&.m-tag-fair {
			background: #ff9900;
		}
		&.m-tag-bad {
			background: #ed3f14;
		}
	}

	.m-condition {
		line-height: 20px;
		font-size: 13px;
		color: #333;
	}

	.m-price-info {
		line-height: 20px;
		font-size: 13px;
		color: #333;
	}

	.m-quality-pending {
		color: #e6a23c;
		font-size: 20px;
		font-weight: bold;
	}
	.m-quality-published {
		color: #19be6b;
		font-size: 20px;
		font-weight: bold;
	}
	.m-quality-offshelf {
		color: #ed3f14;
		font-size: 20px;
		font-weight: bold;
	}

	.m-channel-lines {
		p {
			display: flex;
			align-items: center;
			gap: 6px;
			line-height: 20px;
			white-space: nowrap;
		}

		.m-channel-edit {
			color: #2b7be4;
			font-size: 14px;
			cursor: pointer;
		}
		.m-channel-listing {
			flex-shrink: 0;
		}
		.m-listing-on {
			color: #19be6b;
		}
		.m-listing-off {
			color: #999;
		}
		.m-listing-down {
			color: #999;
		}
		.m-channel-operate {
			flex-shrink: 0;
		}
		.m-operate-publish {
			color: #2b7be4;
		}
		.m-operate-shelf {
			color: #19be6b;
		}
		.m-operate-offshelf {
			color: #e6a23c;
		}
		.m-operate-price {
			color: #722ed1;
		}
		.m-channel-sync {
			flex-shrink: 0;
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.m-sync-pending {
			color: #e6a23c;
		}
		.m-sync-ing {
			color: #2b7be4;
		}
		.m-sync-ok {
			color: #19be6b;
		}
		.m-sync-fail {
			color: #ed3f14;
		}
		.m-channel-info {
			color: #ed3f14;
			font-size: 14px;
			cursor: pointer;
		}
	}

	.m-dismantle-tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		border: 1.5px solid #ed3f14;
		border-radius: 50%;
		color: #ed3f14;
		font-size: 13px;
		font-weight: bold;
	}
</style>
